module.exports = "<template> <span class=tyl-open-icon></span> </template>";